import Delete from "@mui/icons-material/Delete";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

export default function ShopitemzAccountDeletion() {
  const [disabled, setDisabled] = useState(false);
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleClick = () => {
    if (user.email.length > 5 && user.password.length > 3) {
      setDisabled(true);
    }
  };

  const handleChange = (event) => {
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Box textAlign="center" padding={3}>
      <Delete color="error" />
      <Typography
        variant="h6"
        sx={{
          fontSize: 28,
          fontWeight: "bold",
          marginTop: 5,
          marginBottom: 3,
        }}
      >
        Delete my Shopitemz Account
      </Typography>

      <Stack direction="column" spacing={3} alignItems="center">
        <TextField
          onChange={handleChange}
          name="email"
          label="Email *"
          sx={{ minWidth: { xs: "20rem", sm: "25rem" } }}
          color="secondary"
        />
        <TextField
          onChange={handleChange}
          type="password"
          name="password"
          label="Password *"
          sx={{ minWidth: { xs: "20rem", sm: "25rem" } }}
          color="secondary"
        />

        {disabled ? (
          <Typography variant="h6" color="success">
            Submitted for deletion
          </Typography>
        ) : (
          <Button
            onClick={handleClick}
            variant="contained"
            size="large"
            color="secondary"
            sx={{
              textTransform: "none",
              minWidth: { xs: "20rem", sm: "25rem" },
            }}
            disabled={
              user.email.trim().length < 1 || user.password.trim().length < 1
            }
          >
            Submit to Delete
          </Button>
        )}
      </Stack>
    </Box>
  );
}
